import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';

import Button from '../../components/Button/Button';
import CounterField from '../../components/Counter/CounterField';
import CatalogItem from '../catalog-item/CatalogItem';
import Arrow from '../../icons/Arrow';

import { login } from '../../db/User';
import { addToCart, changeCount, removeFromCart, clearCart } from '../../db/Cart';

import { getCartTotal } from '../../services/helpers';

import { useBrowserTab } from '../../hooks/useBrowserTab';

import './basket.css';

const prices = document.querySelector('#prices')
  ? JSON.parse(document.querySelector('#prices').value)
  : 0;

const Basket = (props) => {
  const {
    cart = [
      {
        title: 'sagagsgassgasgags',
      },
    ],
    changeCount,
    removeFromCart,
    clearCart,
    history,
  } = props;

  useBrowserTab({ tabName: 'Корзина' });

  const showPrice = (price) => {
    if (!price) {
      return <i className='fas fa-spinner fa-spin' />;
    }

    return (
      <>
        <span className='uah'>{parseFloat(price * prices.uah).toFixed(0)} грн</span>
        <span className='vertical-separator' />
        <span className='usd'>{parseFloat(price * prices.usd).toFixed(0)}$</span>
      </>
    );
  };

  if (!cart.length) {
    return (
      <section className='page-basket'>
        <div className='section__content'>
          <div className='section__title' style={{ marginBottom: 0 }}>
            Ваш кошик порожній
          </div>
          <div className='flex-container--center'>
            <img
              src='https://img.icons8.com/carbon-copy/320/1a7fc8/clear-shopping-cart.png'
              alt='empty-basket'
            />
          </div>
          <div className='flex-container--center'>
            <Link
              className='square-widget__work square-widget__work--blue about-our-work'
              to='/catalog'
            >
              Перейти до каталогу
              <Arrow height={100} width={100} />
            </Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className='page-basket'>
        <div className='section__content'>
          <div className='page-basket__info'>
            <div className='page-basket__info-products'>
              <div className='page-basket__header'>
                <div className='page-basket__header-title'>Корзина товарів</div>
                <div className='page-basket__header-info'>
                  <div className='page-basket__header-info__count'>{`${cart.length} товари`}</div>
                  <div
                    className='page-basket__header-info__clear'
                    onClick={cart.length ? clearCart : () => {}}
                  >
                    Очистити
                  </div>
                </div>
              </div>
              {cart.map((item) => (
                <CatalogItem
                  {...item}
                  key={item.id}
                  title={item.name}
                  mainImage={item.image.src}
                  price={`${parseFloat(item.price * prices.uah).toFixed(0) * item.count} грн.`}
                  bottomChildren={
                    <div className='catalog-item__basket'>
                      <div className='catalog-item__basket-title'>Кількість шт:</div>
                      <CounterField
                        min={1}
                        onChange={changeCount}
                        max={item.availableQuantity}
                        value={item.count}
                        item={item}
                      />
                      <div className='catalog-item__basket-delete'>Видалити</div>
                    </div>
                  }
                />
              ))}
              {cart.map((item) => (
                <div className='page-basket__info-products__item' key={item.id}>
                  <Link to={`/products/${item.id}`}>
                    <img src={item.image.original} alt={item.image.alt} width={262} height={188} />
                  </Link>
                  <div className='flex-container--column flex-container--between'>
                    <div>
                      <div className='catalog__item__top-title'>{item.name}</div>
                      <div className='catalog__item__top-number'>
                        <span>Номер лота:</span>
                        &nbsp;
                        <span className='catalog__item__top-number__id'>{item.id}</span>
                      </div>
                    </div>
                    <div className='catalog-item__basket'>
                      <div className='flex-container--center'>
                        <div className='catalog-item__basket-title'>Кількість шт:</div>
                        <CounterField
                          min={1}
                          onChange={changeCount}
                          value={item.count}
                          max={item.availableQuantity}
                          item={item}
                        />
                        <div
                          className='catalog-item__basket-delete'
                          onClick={() => removeFromCart(item)}
                        >
                          Видалити
                        </div>
                      </div>
                      <div className='vertical-separator' />
                      <div className='catalog-item__basket-price'>
                        {`${parseFloat(item.price * prices.uah).toFixed(0) * item.count} грн.`}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className='page-basket__info-total'>
              <div className='page-basket__info-total__title'>Загальна вартість:</div>
              <div className='page-basket__info-total__price'>{showPrice(getCartTotal(cart))}</div>
              <Link to='/order'>
                <Button onClick={() => history.push('/order')} disabled={!cart.length}>
                  Замовити
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

function mapStateToProps(state) {
  return {
    cart: state.cart,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({ login, addToCart, removeFromCart, changeCount, clearCart }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Basket));
